module.exports = __webpack_public_path__ + "static/media/kjedeleg.fd238cfe.mp3";